import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { executeOnSingleOrMultiple } from "../../Utils/Utils";

function getItemsFromInitializer(container, map, initializers) {
  var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var res = map.get(container);

  if (!res || force) {
    res = _toConsumableArray(initializers.values()).map(function (t) {
      return t(container);
    });
    map.set(container, res);
  }

  return res;
}

export var Plugins = /*#__PURE__*/function () {
  function Plugins(engine) {
    _classCallCheck(this, Plugins);

    this._engine = engine;
    this.plugins = [];
    this._initializers = {
      interactors: new Map(),
      movers: new Map(),
      updaters: new Map()
    };
    this.interactors = new Map();
    this.movers = new Map();
    this.updaters = new Map();
    this.presets = new Map();
    this.drawers = new Map();
    this.pathGenerators = new Map();
  }

  _createClass(Plugins, [{
    key: "addInteractor",
    value: function addInteractor(name, initInteractor) {
      this._initializers.interactors.set(name, initInteractor);
    }
  }, {
    key: "addParticleMover",
    value: function addParticleMover(name, initMover) {
      this._initializers.movers.set(name, initMover);
    }
  }, {
    key: "addParticleUpdater",
    value: function addParticleUpdater(name, initUpdater) {
      this._initializers.updaters.set(name, initUpdater);
    }
  }, {
    key: "addPathGenerator",
    value: function addPathGenerator(type, pathGenerator) {
      !this.getPathGenerator(type) && this.pathGenerators.set(type, pathGenerator);
    }
  }, {
    key: "addPlugin",
    value: function addPlugin(plugin) {
      !this.getPlugin(plugin.id) && this.plugins.push(plugin);
    }
  }, {
    key: "addPreset",
    value: function addPreset(presetKey, options) {
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      (override || !this.getPreset(presetKey)) && this.presets.set(presetKey, options);
    }
  }, {
    key: "addShapeDrawer",
    value: function addShapeDrawer(types, drawer) {
      var _this = this;

      executeOnSingleOrMultiple(types, function (type) {
        !_this.getShapeDrawer(type) && _this.drawers.set(type, drawer);
      });
    }
  }, {
    key: "destroy",
    value: function destroy(container) {
      this.updaters.delete(container);
      this.movers.delete(container);
      this.interactors.delete(container);
    }
  }, {
    key: "getAvailablePlugins",
    value: function getAvailablePlugins(container) {
      var res = new Map();

      var _iterator = _createForOfIteratorHelper(this.plugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;
          plugin.needsPlugin(container.actualOptions) && res.set(plugin.id, plugin.getPlugin(container));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return res;
    }
  }, {
    key: "getInteractors",
    value: function getInteractors(container) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return getItemsFromInitializer(container, this.interactors, this._initializers.interactors, force);
    }
  }, {
    key: "getMovers",
    value: function getMovers(container) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return getItemsFromInitializer(container, this.movers, this._initializers.movers, force);
    }
  }, {
    key: "getPathGenerator",
    value: function getPathGenerator(type) {
      return this.pathGenerators.get(type);
    }
  }, {
    key: "getPlugin",
    value: function getPlugin(plugin) {
      return this.plugins.find(function (t) {
        return t.id === plugin;
      });
    }
  }, {
    key: "getPreset",
    value: function getPreset(preset) {
      return this.presets.get(preset);
    }
  }, {
    key: "getShapeDrawer",
    value: function getShapeDrawer(type) {
      return this.drawers.get(type);
    }
  }, {
    key: "getSupportedShapes",
    value: function getSupportedShapes() {
      return this.drawers.keys();
    }
  }, {
    key: "getUpdaters",
    value: function getUpdaters(container) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return getItemsFromInitializer(container, this.updaters, this._initializers.updaters, force);
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options, sourceOptions) {
      var _iterator2 = _createForOfIteratorHelper(this.plugins),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var plugin = _step2.value;
          plugin.loadOptions(options, sourceOptions);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "loadParticlesOptions",
    value: function loadParticlesOptions(container, options) {
      var updaters = this.updaters.get(container);

      if (!updaters) {
        return;
      }

      for (var _len = arguments.length, sourceOptions = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        sourceOptions[_key - 2] = arguments[_key];
      }

      var _iterator3 = _createForOfIteratorHelper(updaters),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var updater = _step3.value;
          updater.loadOptions && updater.loadOptions.apply(updater, [options].concat(sourceOptions));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);

  return Plugins;
}();